import React from "react";
import { ArrowLeftRightIcon, Building2Icon, FileSignatureIcon, HeartPulseIcon, MegaphoneIcon, RouteIcon, BoxIcon } from "lucide-react";
import { services } from "../data/content";
const icons: Record<string, BoxIcon> = {
  transferencias: ArrowLeftRightIcon,
  clubes: Building2Icon,
  contratos: FileSignatureIcon,
  bienestar: HeartPulseIcon,
  carrera: RouteIcon,
  imagen: MegaphoneIcon
};
export function Services() {
  return <section id="servicios" className="scroll-mt-20 bg-ink text-paper" data-id="element-213" data-mp="13wmqz440aptr">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32" data-id="element-214" data-mp="z4wdip9rvly4">
        <div className="max-w-2xl" data-id="element-215" data-mp="u61mx15kct3g">
          <p className="text-sm font-medium text-gold" data-id="element-216" data-mp="u73ag53rn822">Servicios</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-217" data-mp="q4q4bfl3x84r">
            Todo lo que la carrera necesita, en un mismo equipo.
          </h2>
        </div>

        <ul className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-218" data-mp="l7g9tliv26a2">
          {services.map(service => {
          const Icon = icons[service.id];
          return <li key={service.id} className="flex flex-col rounded-lg border border-gold/50 bg-ink-soft p-8" data-id="element-219" data-mp="36beqztzlv5gl">
                <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-220" data-mp="3b4r5vcehfxw5" />
                <h3 className="mt-6 text-lg font-semibold" data-id="element-221" data-mp="2xckr9uqz9yyt">{service.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-paper/70" data-id="element-222" data-mp="32amhczmtmyjs">{service.description}</p>
              </li>;
        })}
        </ul>

      </div>
    </section>;
}